import { render, staticRenderFns } from "./lainaa24.vue?vue&type=template&id=882dfd94&"
import script from "./lainaa24.vue?vue&type=script&lang=js&"
export * from "./lainaa24.vue?vue&type=script&lang=js&"
import style0 from "./lainaa24.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports